import { render } from "./ValueSelector.vue?vue&type=template&id=3b8640e4"
import script from "./ValueSelector.vue?vue&type=script&lang=js"
export * from "./ValueSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__